import { Identite } from '../../../identite/shared/classes/identite';
import { Role } from '../../../identite/shared/classes/role';
import {AgrementBureau} from '../../../agence/shared/classes/agrement-bureau';
import { FacturePersonnalisation } from '../../../facturation/shared/classes/facture-personnalisation';

export interface IBureauConfig {
    cbu_id: string;
    cbu_bureaux_id: string;
    cbu_prefix_facture_client: string;
    cbu_annee_calendaire: number;
    cbu_debut_exercice: Date;
    cbu_fin_exercice: Date;
    cbu_exercice_reprise: number;
    cbu_numero_reprise: string;
}

export interface IBureau {
    id: string;
    ref: string;
    metier: string;
    statut: string;
    archive: string;
    agence_id: string;
    acl_roles_id: string;
    roles_id: string;
    identite: Identite;
    role: Role;
    z16ProChamps: Array<any>;
}

export class Bureau {
    id: string;
    ref: string;
    metier: string;
    statut: string;
    archive: string;
    agence_id: string;
    acl_roles_id: string;
    roles_id: string;
    identite: Identite;
    role: Role;
    agrement_bureau: AgrementBureau;

    z16ProChamps: Array<any> = [];

    facture_personnalisation: FacturePersonnalisation = new FacturePersonnalisation();


    constructor(data?: any) {
        if (!data) {
            data = [];
        }
                                  // id = 0 -> cheat pour simuler le bureau 'Tous' uniquement pour affichage correct dans le select du breadcrumb
        this.id                 = data['id'] || data['id'] === '0' ? data['id'] : null;
        this.ref                = data['ref'] ? data['ref'] : null;
        this.metier             = data['metier'] ? data['metier'] : null;
        this.statut             = data['statut'] ? data['statut'] : null;
        this.archive            = data['archive'] ? data['archive'] : null;
        this.agence_id          = data['agence_id'] ? data['agence_id'] : null;
        this.acl_roles_id       = 'agence_bureau';
        this.roles_id           = data['roles_id'] ? data['roles_id'] : null;
        this.identite           = data['identite'] ? new Identite(data['identite']) : new Identite();
        this.role               = data['role'] ? new Role(data['role']) : new Role();
        this.agrement_bureau     = data['agrement_bureau'] ? new AgrementBureau(data['agrement_bureau']) : new AgrementBureau({abu_bureau_id: this.id});
    }
}
